import React, {Component, createRef} from "react";
import PropTypes from "prop-types";

class GemFormField extends Component {

  constructor(props) {
    super(props);

    this.refInputField = createRef();
  }

  render() {
    return <div className="mb-4 mt-4">
      <label htmlFor="password" className="block text-sm text-gray-400 mb-1">
        {this.props.labelText}
      </label>
      <input ref={this.refInputField} id={this.props.id} type={this.props.type} placeholder={this.props.placeholder} className="w-full bg-[#010409] border border-[#30363d] rounded px-3 py-2 text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500"/>
    </div>;  }
}

GemFormField.propTypes = {
  labelText: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string
}
export default GemFormField;
